export default __webpack_public_path__ + "static/media/Pet Golden Lotus.1791aa64.jpg";